<template>
  <div class="thin-scroll" style="max-height: 100%; overflow: scroll;">
    <div v-if="!facetLoading || selectedMainFacetValueId" :class="{'filter-category--scrollable': scrollable}">
      <div v-for="(item, index) in facetsWithValues" :key="index" class="filter-category">
        <base-dropdown
          block
          :disabled="!isFacetDropdownEnabled(item)"
          :label="fineTuneFacetName(item.name) | capitalize | truncate(50)"
          :active=" isExpanded(index, item)"
          size="m"
          :class="`filter-category__title ${!isFacetDropdownEnabled(item) ? 'filter-category__disabled' : ''}`"
          @click="toggleExpand(index, item)"
        />
        <base-transition-expand>
          <div v-if=" isExpanded(index, item)" class="subitem filter-category__options">
            <div v-if="item.facet_values.length > 8" class="base-search">
              <input
                v-model="facetSearch[index]" placeholder="Search" type="text"
                class="mini-search"
              >
              <base-icon
                class="icon"
                icon="search-base"
              />
            </div>
            <div v-if="item.facet_values.length > 8" class="spacer" />
            <template v-if="item.main_facet">
              <radio-input-filter
                :radio-items="mainFacetValues"
                :selected-radio-item="selectedMainFacetValueId"
                @filter-radio-item-selected="$emit('main-facet-value-selected', $event)"
              />
            </template>
            <template v-for="(subitem, subitemIndex) in item.facet_values" v-else>
              <base-checkbox
                v-if="subitem.name && (subitem.name.toLowerCase().indexOf(facetSearch[index].trim().toLowerCase()) !=-1)"
                :key="subitemIndex + '-' + index"
                :value="selectedFacets.includes(subitem.id)"
                block
                black
                :disabled="getIsFilterDisabled(subitem, item)"
                :label="subitem.name | capitalize | truncate(50)"
                @input="$emit('toggle-select', subitem)"
              />
            </template>
          </div>
        </base-transition-expand>
      </div>
    </div>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus';
import RadioInputFilter from './RadioInputFilter';

export default {
  name: 'CatalogFilter',
  components: [
    RadioInputFilter,
  ],
  props: {
    scrollable: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    selectedFacets: { // e.g. Vuex state:  catalog.selectedFacets
      type: Array,
      default: () => [],
    },
    selectedMainFacetValueId: {
      type: Number,
      default: null,
    },
    mainFacetWithValues: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: [], // Selected subcategories
      facetSearch: [],
      showFilter: false,
    };
  },
  computed: {
    facetsWithValues() {
      const facet = this.items.filter((item) => item.facet_values.length > 0);
      if (facet.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showFilter = true;
      }
      EventBus.$emit('showFilter', this.showFilter);
      return facet;
    },
    mainFacetValues() {
      return this.mainFacetWithValues ? this.mainFacetWithValues.facet_values : null;
    },
    facetLoading() {
      return this.$store.getters['catalog/facetLoading'];
    },
    facetsWithAtLeastOneValueSelected() {
      const withAtLeastOne = [];
      if (this.selectedMainFacetValueId) {
        withAtLeastOne.push(this.mainFacetWithValues.id);
      }

      this.items.forEach((item) => {
        const facetValuesIds = item.facet_values.map((facet_value) => facet_value.id);

        facetValuesIds.forEach((facetValueId) => {
          if (this.selectedFacets.includes(facetValueId)) {
            withAtLeastOne.push(item.id);
          }
        });
      });
      return withAtLeastOne;
    },
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.facetSearch = this.facetsWithValues.map(() => '');
      },
    },
    selectedMainFacetValueId(oldId, newId) {
      if (oldId !== newId) {
        const secondaryFacetIndex = 1;
        this.$set(this.expanded, secondaryFacetIndex, true);
      }
    },
  },
  mounted() {
    this.facetSearch = this.facetsWithValues.map(() => '');
  },
  methods: {
    isFacetDropdownEnabled(facet) {
      if (!this.selectedMainFacetValueId) {
        return false;
      }

      if (facet.main_facet && this.selectedMainFacetValueId) {
        return true;
      }

      const itemParentFacetObject = this.getFacetParentObject(facet);
      if (itemParentFacetObject && !itemParentFacetObject.is_mandatory) {
        return true;
      }

      const parentFacetHasValue = this.facetsWithAtLeastOneValueSelected.includes(facet.parent);
      return parentFacetHasValue;
    },
    getFacetFromFacetValueId(facetValueId) {
      return this.items.find((facet) => facet.facet_values.map((facetValue) => facetValue.id).includes(facetValueId));
    },
    getIsFilterDisabled(subitem, item) {
      if (!this.selectedMainFacetValueId) {
        return true;
      }

      const itemParentFacetObject = this.getFacetParentObject(item);

      if (itemParentFacetObject && !itemParentFacetObject.is_mandatory) {
        return false;
      }

      if (!this.facetsWithAtLeastOneValueSelected.includes(subitem.facet_parent_id)) {
        return true;
      }
      return false;
    },
    fineTuneFacetName(name) { // XXX MATCHESFASHION only!
      const PRODUCT_CATALOG_FACET_GROUP = 'Group';

      if (name === PRODUCT_CATALOG_FACET_GROUP) {
        return 'Category';
      } else {
        return name;
      }
    },
    isExpanded(index, item = null) {
      if (!this.selectedMainFacetValueId) {
        return false;
      }

      if (item && item.main_facet && this.selectedMainFacetValueId) {
        return true;
      }

      const itemParentFacetObject = this.getFacetParentObject(item);
      if (itemParentFacetObject && !itemParentFacetObject.is_mandatory) {
        return this.expanded[index];
      }

      if (item && !item.main_facet && !this.facetsWithAtLeastOneValueSelected.includes(item.parent)) {
        return false;
      }
      return this.expanded[index];
    },
    getFacetParentObject(item) {
      return this.items.find((itemFacet) => itemFacet.id === item.parent);
    },
    toggleExpand(index, item = null) {
      if (item) {
        const itemParentFacetObject = this.getFacetParentObject(item);

        if (itemParentFacetObject && !itemParentFacetObject.is_mandatory) {
          this.$set(this.expanded, index, !this.expanded[index]);
          return;
        }

        if (itemParentFacetObject && !item.main_facet && !this.facetsWithAtLeastOneValueSelected.includes(item.parent)) {
          return;
        }
      }
      this.$set(this.expanded, index, !this.expanded[index]);
    },
    onSearch($event) {
      this.$emit('search', $event);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-category{
  &__title{
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    color: $dark-black;
  }
  &--scrollable {
    overflow-y: auto;
    max-height: 100vh;
  }
  &__disabled{
    color: $gray-light-2;
    :hover{
      cursor: not-allowed;
    }
  }
}
.subitem{
  max-height: 234px;
  overflow-y: auto;
  // max-height: 280px;
}
::v-deep .base-checkbox__button {
  display: flex;
  & .base-checkbox__label {
    display: inline-block;
  }
}
::v-deep .base-search__input {
  &::placeholder {
    color: $gray-light-2;
  }
}
::v-deep .base-text--light{
  font-family: "SilkaMedium"
}
::v-deep .base-checkbox__button .base-checkbox__label {
  font-family: "SilkaLight";
  font-weight: 400 !important;
  font-size: 14px;
}

.mini-search{
  font-family: $font-family-sans-serif-light;
  font-size: 0.75rem;
  background-color: #FFF;
  color: $black;
  border: 1px solid #C6C6C6;
  padding: 8.5px 8px 8.5px 30px;
  border-radius: 5px;
  min-width: 100%;
  height:30px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: outline 0.2s;
  outline: solid 5px transparent;
  &:focus{
      outline: solid 0px #0A0A0A;
      border: 1px solid #0A0A0A;
      border-radius: 5px;
    }
}
.icon{
    position: absolute;
    left: 10px;
    height: 15px;
    width:15px;
    top:8px;
}
.base-search{
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: auto;
  position: relative;
  height: toRem(35px);
  height: 36px;
  justify-content:center;
  position:absolute;
  width: 95%;
  background-color:#FFF;
  z-index: 100;

}
.spacer{
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: auto;
  position: relative;
  height: toRem(35px);
  height: 36px;
  justify-content:center;
  width: 95%;
  background-color:#FFF;
  z-index:99;
}

</style>
